
const BASE = "BASE";
const GROWTH = "GROWTH";
const AGGRESSIVE = "AGGRESSIVE";

module.exports = {
    BASE,
    GROWTH,
    AGGRESSIVE
}